export const AnnonuceVisibleFilters = "Showing filters {0} through {1}";
export const ApplyChangesFilterBarText = "Apply";
export const ClearAndDismissFilterBarLinkLabel = "Clear and dismiss filters";
export const ClearFilterBarLinkLabel = "Clear filters";
export const FilterBarAriaLabel = "Filter bar";
export const FilterPageLeftAriaLabel = "See previous group of filters";
export const FilterPageRightAriaLabel = "See next group of filters";
